export default __webpack_public_path__ + "static/KINGRARE-03567e3774e522e5af4690207422a94a.png";